import { getUTCDate } from '@/shared/utils/date';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import styled from 'styled-components';
import { TransformedAssetClassForecastValueDto } from '../../../../../types';
import MobileSumFooter from './mobileSumFooter';

interface MobileTableProps {
  tableData: TransformedAssetClassForecastValueDto[];
}

const MobileTable = ({ tableData }: MobileTableProps) => {
  const TableRow = ({ el }: { el: TransformedAssetClassForecastValueDto }) => {
    return (
      <CustomMobileTableRowWrap key={el.name}>
        <MobileRow>
          <MobileRowTitle>Deal</MobileRowTitle>
          <MobileRowValue>{el.name}</MobileRowValue>
        </MobileRow>

        {el.values.map((item) => (
          <MobileRow key={el.name + item.date}>
            <MobileRowTitle>{getUTCDate(new Date(item.date)).toUpperCase()}</MobileRowTitle>
            <MobileRowValue>
              <FormattingTooltip zIndex={1000}>{item.value}</FormattingTooltip>
            </MobileRowValue>
          </MobileRow>
        ))}
      </CustomMobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableData?.length ? (
        <>
          {tableData.map((el) => {
            return <TableRow el={el} key={el.name} />;
          })}
          <MobileSumFooter tableData={tableData} />
        </>
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const CustomMobileTableRowWrap = styled(MobileTableRowWrap)`
  background-color: ${({ theme }) => theme.layer.base};
`;
